import Service from "./Service";
import User from "@/core/user";

class LoginService {
  constructor(props) {
    this.PATH = {
      ZFB_LOGIN: "customer/anon/login/login",
      LOGIN: "account/public/login/bindPhone",
      LOGIN_OUT: "c/login/outV2",
      VERIFY_CODE: "horn/anon/message/sendAuthCode",
      AUTO_LOGIN: "customer/anon/wechat/getOpenId",
      INST_ICON: "anon/institution/getInstitution",
      WECHAT_SIGN: "customer/anon/wechat/getWechatJSAPISignature",
      VOICE_CODE: "customer/anon/sms/sendVoiceCode",
      WECHAT_LOGIN: "c/login/loginByOpenId",
      TEST: "customer/public/test/test",
      VOICECODE_NEW: "customer/anon/sms/sendVoiceCode",
      BIND_PHONE: "account/public/login/bindPhone",
      PHONE_STUDENT: "customer/public/groupToStudent/newBindAbleList",
      CONNECT_STUDENT: "customer/public/groupToStudent/createNew",
      GET_WX_AVATAR: 'customer/anon/wechat/getUserInfo',
    };
  }
  /**
   * 登录接口
   * @param phone {手机号}
   * @param code {验证码}
   */
  login(authCode, phone) {
    const params = {
      authCode: authCode,
      phone: phone,
      xmToken: User.token()
    };
    return Service.doAsyncRequest(this.PATH.LOGIN, {
      params: JSON.stringify(params),
      queryUserInfo: false,
      contentType: "application/json",
      heimdall: true
    });
  }

  // 获取微信头像和昵称
  getAvatar() {
    return axios.post(this.PATH.GET_WX_AVATAR, {
      appId: User.appId(),
      code: window.getParameterByName('code')
    })
  }

  /**
   * 支付宝登录
   */
  loginOnZFB(phone, code) {
    const params = {
      identifier: phone,
      credential: code,
      appTermEnum: 'CUSTOMER_WECHAT_H5',
      identityTypeEnum: 'PHONE',
      credentialTypeEnum: 'SMS_CAPTCHA',
      serverType: 'C_LOGIN',
    }
    return Service.doAsyncRequest(this.PATH.ZFB_LOGIN, {
      params: JSON.stringify(params),
      queryUserInfo: false,
      contentType: "application/json",
      heimdall: true
    })
  }

  publicCode(phone) {
    const params = {
      serverType: "BIND_STUDENT",
      phone
    };
    return Service.doAsyncRequest(this.PATH.VERIFY_CODE, {
      params: JSON.stringify(params),
      queryUserInfo: false,
      contentType: "application/json",
      heimdall: true
    });
  }

  voiceCode(certificate) {
    const params = {
      certificate
    };
    return Service.doAsyncRequest(this.PATH.VOICECODE_NEW, {
      params: JSON.stringify(params),
      queryUserInfo: false,
      contentType: "application/json",
      heimdall: true
    });
  }

  test() {
    const params = {
      name: "zz",
      age: 12
    };

    return Service.doAsyncRequest(this.PATH.TEST, {
      params: JSON.stringify(params),
      queryUserInfo: false,
      contentType: "application/json",
      heimdall: true
    });
  }

  wechatLogin(appId, openId, userKey) {
    const params = {
      appId: appId,
      openId: openId,
      deviceType: 2,
      userKey: userKey
    };

    return Service.doAsyncRequest(this.PATH.WECHAT_LOGIN, {
      params: params,
      queryUserInfo: false,
      sync: true,
      reject: true
    });
  }

  /**
   * 退出
   * @param openId
   * @param success
   */
  loginOut() {
    return Service.doAsyncRequest(this.PATH.LOGIN_OUT);
  }

  /**
   * 手机发送验证码
   * @param phone
   * @returns {*}
   */
  generateVerifyCode(phone) {
    const params = {
      serverType: "BIND_STUDENT",
      phone
    };
    return Service.doAsyncRequest(this.PATH.VERIFY_CODE, {
      params: JSON.stringify(params),
      contentType: "application/json",
      heimdall: true
    });
  }

  /**
   * 验证手机
   * @param phone
   * @returns {*}
   */
  bindPhone(phone, authCode) {
    const params = {
      authCode: authCode,
      phone: phone,
      xmToken: User.token()
    };
    return Service.doAsyncRequest(this.PATH.BIND_PHONE, {
      params: JSON.stringify(params),
      contentType: "application/json; charset=UTF-8",
      heimdall: true
    });
  }

  /**
   * 手机发送语音验证码
   */
  generateVoiceVerifyCode(certificate) {
    const params = {
      certificate
    };
    return Service.doAsyncRequest(this.PATH.VOICE_CODE, {
      params: JSON.stringify(params),
      contentType: "application/json; charset=UTF-8",
      heimdall: true
    });
  }

  /**
   * 根据weixinCode获取用户是否应该自动登陆
   * @param weixinCode
   * @param appId
   * @returns {*}
   */
  autoLogin(weixinCode, appId, userKey) {
    const params = {
      code: weixinCode,
      appId: appId,
      // userKey: userKey
    };

    return Service.doAsyncRequest(this.PATH.AUTO_LOGIN, {
      contentType: "application/json; charset=UTF-8",
      params: JSON.stringify(params),
      heimdall: true
    });
  }

  //机构icon
  institutionIcon(instId) {
    const params = {
      instId: instId
    };
    return axios.Customer(this.PATH.INST_ICON, params)
  }

  getWechatAuthConfig() {
    const params = {
      url: location.href.split("#")[0],
      appId: User.appId()
    };
    return Service.doAsyncRequest(this.PATH.WECHAT_SIGN, {
      params: JSON.stringify(params),
      contentType: "application/json; charset=UTF-8",
      heimdall: true
    });
  }

  getPhoneStudent(phone, code) {
    const params = {
      phone,
      code,
      appId: User.appId()
    };
    return Service.doAsyncRequest(this.PATH.PHONE_STUDENT, {
      params: JSON.stringify(params),
      contentType: "application/json; charset=UTF-8",
      heimdall: true
    });
  }

  connectStudent(idList, phone, appId) {
    const params = {
      studentIds: idList,
      phone,
      appId
    };
    return Service.doAsyncRequest(this.PATH.CONNECT_STUDENT, {
      params: JSON.stringify(params),
      contentType: "application/json; charset=UTF-8",
      heimdall: true
    });
  }
}

export default new LoginService();



// WEBPACK FOOTER //
// ./src/service/LoginService.js